<template>
    <span class="ticket_status" :class="'status_' + value">{{value|ticketStatusName}}</span>
</template>

<script>
export default {
    name : 'MobileTicketStatus',

    props : ['value']
}
</script>

<style scoped>
    .status_2 {
        color: #da511b;
        background-color : #FFF!important;
    }

    .status_3 {
        color: #09ae14;
        background-color : #FFF!important;
    }

    .status_5 {
        color: #6d3a6d;
        background-color : #FFF!important;
    }

    .status_6 {
        color: #77777e;
        background-color : #FFF!important;
    }

    .ticket_status {
        border: 1px solid #dcdfe6;
        border-radius: 2px;
        padding: 0 2px;
        background-color: #ecf5ff;
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile-ticket/MobileTicketStatus.vue